export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7708.5e6f5f9f.jpg";